module.exports = __webpack_public_path__ + "img/bg_user_info_no_vip.361054a1.png";